var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Injectable } from '@angular/core';
import { DataType } from '../../../main/workshop/core/variable/data-type';
import { DisplayDataType } from '../../../main/workshop/element-setting/numerical-display/display-data-type-enum';
var DataTypeService = /** @class */ (function () {
    function DataTypeService() {
        this.defaultIntegerDigits = 4;
        this.defaultFractionDigits = 0;
        this.dataTypeList = new Map();
        this.dataTypeList[0] = 'Bit';
        this.dataTypeList[1] = 'UInt16';
        this.dataTypeList[2] = 'Int16';
        this.dataTypeList[3] = 'Bcd16';
        this.dataTypeList[4] = 'Hex16';
        this.dataTypeList[5] = 'Binary16';
        this.dataTypeList[11] = 'UInt32';
        this.dataTypeList[12] = 'Int32';
        this.dataTypeList[13] = 'Bcd32';
        this.dataTypeList[14] = 'Hex32';
        this.dataTypeList[15] = 'Binary32';
        this.dataTypeList[16] = 'Single';
        this.dataTypeList[30] = 'String';
    }
    DataTypeService.prototype.getDataTypeNameById = function (id) {
        return this.dataTypeList[id];
    };
    DataTypeService.prototype.hasDeadValue = function (id) {
        return id !== 0 && id !== 30;
    };
    DataTypeService.prototype.isHexType = function (displayDataType) {
        return displayDataType === DisplayDataType.HexadecimalSystem;
    };
    DataTypeService.prototype.isBinaryType = function (displayDataType) {
        return displayDataType === DisplayDataType.Binary;
    };
    DataTypeService.prototype.isHexOrBinaryType = function (displayDataType) {
        return displayDataType === DisplayDataType.HexadecimalSystem || displayDataType === DisplayDataType.Binary;
    };
    DataTypeService.prototype.isFloat = function (dataType) {
        return dataType === DataType.Float;
    };
    /**
     * 获取数据型号最大长度
     * @param id
     */
    DataTypeService.prototype.getValueMaxLength = function (dataType, displayDataType) {
        var maxLength = 0;
        switch (displayDataType) {
            case DisplayDataType.DecimalSystem: // 十进制
                maxLength = 10;
                break;
            case DisplayDataType.HexadecimalSystem: // 16进制
                maxLength = 8;
                break;
            case DisplayDataType.Binary: // 二进制
                maxLength = 32;
                break;
        }
        if (dataType === DataType.Float) {
            maxLength = 10;
        }
        return maxLength;
    };
    /**
     * 是否支持小数位
     * @param id
     */
    DataTypeService.prototype.isSupportFractionDigit = function (dataType, displayDataType) {
        if (dataType !== DataType.Int32 && dataType !== DataType.Float.valueOf()) {
            return false;
        }
        return (dataType === DataType.Int32 && displayDataType === DisplayDataType.DecimalSystem) || dataType === DataType.Float.valueOf();
    };
    /**
     * 是否支持数值运算
     * @param id
     */
    DataTypeService.prototype.isSupportNumericalOperation = function (dataType, displayDataType) {
        if (dataType !== DataType.Int32.valueOf() && dataType !== DataType.Float.valueOf()) {
            return false;
        }
        return (dataType === DataType.Int32 && displayDataType === DisplayDataType.DecimalSystem) || dataType === DataType.Float.valueOf();
    };
    /**
    * 如果是二进制及十六进制的十进制，转换成16进制
    * @param value
    * @param id
    */
    DataTypeService.prototype.formatDisplayValue = function (value, id) {
        if (this.isHexOrBinaryType(id)) {
            return (parseInt(value)).toString(16).toUpperCase();
        }
        return value;
    };
    /**
    * 把16进制数据转换成10进制
    * @param value
    * @param id
    */
    DataTypeService.prototype.formatToDecimal = function (value, id) {
        if (this.isHexOrBinaryType(id)) {
            return parseInt(value, 16);
        }
        return value;
    };
    /**
     * 获取数据型号最小值
     * @param id
     * @param? integerDigits
     * @param? fractionDigits
     */
    DataTypeService.prototype.getMinValue = function (dataType, displayDataType, integerDigits, fractionDigits) {
        var minValue = 0;
        switch (displayDataType) {
            case DisplayDataType.DecimalSystem: // 十进制
                minValue = -2147483648;
                break;
            case DisplayDataType.HexadecimalSystem: // 16进制
                minValue = 0;
                break;
            case DisplayDataType.Binary: // 二进制
                minValue = 0;
                break;
        }
        if (dataType === DataType.Float) {
            minValue = -1000000000;
        }
        var digitsLength = integerDigits;
        if (fractionDigits) {
            digitsLength = digitsLength + fractionDigits;
        }
        if (digitsLength) {
            if (minValue.toString().length - 1 > digitsLength) {
                minValue = -this.getFillMaxValue(digitsLength);
            }
        }
        if (this.isFloat(dataType) && fractionDigits) {
            minValue = minValue / Math.pow(10, fractionDigits);
        }
        return minValue;
    };
    /**
     * 获取数据型号最大值
     * @param id
     * @param? integerDigits
     * @param? fractionDigits
     */
    DataTypeService.prototype.getMaxValue = function (dataType, displayDataType, integerDigits, fractionDigits) {
        var maxValue;
        switch (displayDataType) {
            case DisplayDataType.DecimalSystem: // 十进制
                maxValue = 2147483647;
                break;
            case DisplayDataType.HexadecimalSystem: // 16进制
                maxValue = 'FFFFFFFF';
                break;
            case DisplayDataType.Binary: // 二进制
                maxValue = '11111111111111111111111111111111';
                break;
        }
        if (dataType === DataType.Float) {
            maxValue = 1000000000;
        }
        if (integerDigits) {
            var digitsLength = integerDigits;
            if (fractionDigits) {
                digitsLength = digitsLength + fractionDigits;
            }
            if (digitsLength) {
                if (maxValue.toString().length > digitsLength) {
                    if (this.isHexOrBinaryType(displayDataType)) {
                        maxValue = maxValue.substring(0, digitsLength);
                    }
                    else {
                        maxValue = this.getFillMaxValue(digitsLength);
                    }
                }
            }
            if (this.isBinaryType(displayDataType)) {
                maxValue = parseInt(maxValue, 2).toString(16).toUpperCase();
            }
        }
        else {
            if (this.isHexOrBinaryType(displayDataType)) {
                maxValue = this.formatToDecimal(maxValue, displayDataType);
            }
        }
        if (this.isFloat(dataType) && fractionDigits) {
            maxValue = maxValue / Math.pow(10, fractionDigits);
        }
        return maxValue;
    };
    DataTypeService.prototype.getFillMaxValue = function (num) {
        var text = '9';
        for (var i = 1; i < num; i++) {
            text = "9" + text;
        }
        return text;
    };
    DataTypeService.prototype.getMaxNumberValue = function (id) {
        switch (id) {
            case 1: // UInt16
            case 4: // Hex16
            case 5: // Binary16
                return 65535;
            case 2: // Int16
                return 32767;
            case 3: // Bcd16
                return 9999;
            case 11: // UInt32
            case 14: // Hex32
            case 15: // Binary32
                return 4294967295;
            case 12: // Int32
                return 2147483647;
            case 13: // Bcd32
                return 99999999;
            case 16: // Single
                return 1000000000;
        }
    };
    DataTypeService.prototype.formatDataType = function (dataType, bitIndexEnabled, lc) {
        var dataTypeKey = bitIndexEnabled ?
            this.getDataTypeNameById(0) : this.getDataTypeNameById(dataType);
        return dataTypeKey ? lc(dataTypeKey) : '-';
    };
    DataTypeService = __decorate([
        Injectable()
    ], DataTypeService);
    return DataTypeService;
}());
export { DataTypeService };
